import { LogOut } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button, type ButtonProps } from '@/shared/ui';
import { useLogout } from '../model/useLogout';

export interface LogoutButtonProps extends Omit<ButtonProps, 'onClick' | 'loading' | 'children'> {
  /** Ukrywa etykiete i zostawia sama ikone — do zwezonych paskow nawigacji. */
  iconOnly?: boolean;
  /** Dokad przekierowac po wylogowaniu. */
  redirectTo?: string;
}

/** Przycisk wylogowania gotowy do uzycia w kazdym ukladzie strony. */
export function LogoutButton({
  iconOnly = false,
  redirectTo,
  variant = 'secondary',
  ...props
}: LogoutButtonProps) {
  const { t } = useTranslation('common');
  const { logout, isLoggingOut } = useLogout(redirectTo ? { redirectTo } : {});

  return (
    <Button
      variant={variant}
      loading={isLoggingOut}
      onClick={() => void logout()}
      leadingIcon={<LogOut className="size-4" />}
      aria-label={iconOnly ? t('actions.logout') : undefined}
      {...props}
    >
      {!iconOnly && t('actions.logout')}
    </Button>
  );
}
